import React, {useState, useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import moment from "moment";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import NewsList from '../../common/NewsList'
import CardTextOnImage from '../../common/cardNews/CardTextOnImage'
import SummaryCardLayout from "./SummaryCardLayout";
import {getHomeDataAPI} from "../../../apis/news_service";
import {getMyDataAPI} from "../../../apis/my_service";
import Loading from "../../../pages/error/Loading";
import more from '../../../assets/images/ico_more.svg'


const IndustryNewsLayout = () => {
    const navigate = useNavigate()
    const today = moment().format('YYYY년 MM월 DD일');

    const [loading, setLoading] = useState(true);

    const [orderType, setOrderType] = useState('NEWS') // 긍정뉴스 조회기준 NEWS or CHANGE
    const [positiveData, setPositiveData] = useState(null); // 긍정산업 모든 데이터
    const [tSummarymsg,setTSummarymsg] = useState('') // 오늘의 큐레이팅
    const [mSummarymsg,setMSummarymsg] = useState('') // 3개월 통계 큐레이팅
    const [newsList, setNewsList] = useState([]); // 뉴스 리스트
    const [industryList, setIndustryList] = useState([]); // 종목 리스트
    const [orderType_n, setOrderType_n] = useState('NEWS') // 부정뉴스 조회기준 NEWS or CHANGE
    const [negativeData, setNegativeData] = useState(null); // 부정산업 모든 데이터
    const [tSummarymsg_n,setTSummarymsg_n] = useState('') // 오늘의 큐레이팅
    const [mSummarymsg_n,setMSummarymsg_n] = useState('') // 3개월 통계 큐레이팅
    const [newsList_n, setNewsList_n] = useState([]); // 뉴스 리스트
    const [industryList_n, setIndustryList_n] = useState([]); // 종목 리스트

    const moreBtnClick = () => {
        //TODO : 마이기업 전체에서 더보기 클릭 시 이동 페이지?

        // if(window.location.pathname.includes('mycorp')){
        //     navigate('/mycorp/industry')
        // }else {
            navigate('/industry')
        // }

        } // 디테일 페이지 이동
    
    // const moveToNews = (id, name, signal) => {navigate(`/news/${id}`, {state: {stockname: name, signal: signal,  range: name.slice(0,-3)}})}
    const moveToNews = (type,signal,title,range) => {navigate(`/news/${type}/${signal === '긍정' ? "positive" : 'negative'}`, {state: {type:type,title:title, range: range}})}

    const industryHomeData = () => {
        getHomeDataAPI('industry','1', orderType,5).then(res => {
            setPositiveData(res)
            setTSummarymsg(res.tSummarymsg)
            setMSummarymsg(res.mSummarymsg)
            setNewsList(res.newslist)
            setIndustryList(res.industrylist.slice(-5))
            setLoading(false)
        })
        getHomeDataAPI('industry','2', orderType_n, 5).then(res => {
            setNegativeData(res)
            setTSummarymsg_n(res.tSummarymsg)
            setMSummarymsg_n(res.mSummarymsg)
            setNewsList_n(res.newslist)
            setIndustryList_n(res.industrylist.slice(-5))
            setLoading(false)
        })
    }

    const industryMyData = () => {
        getMyDataAPI('industry','1', orderType, 5).then(res => {
            setPositiveData(res)
            setTSummarymsg(res.tSummarymsg)
            setMSummarymsg(res.mSummarymsg)
            setNewsList(res.newslist)
            setIndustryList(res.industrylist.slice(-5))
            setLoading(false)
        })
        getMyDataAPI('industry','2', orderType_n,5).then(res => {
            setNegativeData(res)
            setTSummarymsg_n(res.tSummarymsg)
            setMSummarymsg_n(res.mSummarymsg)
            setNewsList_n(res.newslist)
            setIndustryList_n(res.industrylist.slice(-5))
            setLoading(false)
        })
    }

    useEffect(()=>{
        if(window.location.pathname.includes('mycorp')){
            industryMyData()
        }else {
            industryHomeData()
        }
    },[orderType, orderType_n])

    return (
        <>
            <div className='industry inner_container'>
                <div className='divider'>
                    <span className='title_lg'>산업 뉴스</span>
                    <div className='plus_icon'>
                        <span className='more' >더보기</span>
                        <AddCircleIcon sx={{width:'32px', height:'32px',}} onClick={moreBtnClick}/>
                    </div>

                </div>
                {loading? <Loading/> :
                    <>
                        <div className='main_layout'>
                            <div className='positive_area'>
                                <div className='flex_layout'>
                                    <p>
                                        <span onClick={()=>setOrderType('NEWS')} className={`${orderType === 'NEWS'? 'on' : ''}`}>긍정 뉴스가 많은 기업 순</span>
                                        <span className='separator'>·</span>
                                        <span onClick={()=>setOrderType('CHANGE')}  className={`${orderType === 'NEWS'? '' : 'on'}`}>상승률 높은 기업 순</span>
                                    </p>
                                    <div className='click'>
                                        {/*<span onClick={()=>moveToNews(newsList[0].stockcode, newsList[0].stockname, '긍정')}>뉴스 더보기</span>*/}
                                        <span className='click' onClick={()=>moveToNews('industry', '긍정', newsList[0].FICS_sub, newsList[0].FICS_sub)}>뉴스 더보기</span>
                                        <img src={more} alt='more'/>
                                    </div>

                                </div>
                                <div className='flex_layout'>
                                    <div className='curate_box'>
                                        <p className='curate_msg'>
                                            <span>{today}</span><br/>
                                            {tSummarymsg + '\n\n' + mSummarymsg}
                                        </p>
                                    </div>
                                    {newsList && <CardTextOnImage news={newsList[0]}/>}
                                </div>
                                {/*<NewsList newsList={newsList.slice(1)} type='horizontal' size='2' main='main'/>*/}
                                <NewsList newsList={newsList.slice(1)} type='vertical' size='3' main='main'/>
                            </div>

                            <div className='negative_area'>
                                <div className='flex_layout'>
                                    <p>
                                        <span onClick={()=>setOrderType_n('NEWS')}  className={`${orderType_n === "NEWS"? 'on' : ''}`}>부정 뉴스가 많은 기업 순</span>
                                        <span className='separator'>·</span>
                                        <span onClick={()=>setOrderType_n('CHANGE')}  className={`${orderType_n === "CHANGE"? 'on' : ''}`}>하락률 높은 기업 순</span>
                                    </p>
                                    <div className='click'>
                                        <span className='click' onClick={()=>moveToNews('industry', '부정', newsList_n[0].FICS_sub, newsList_n[0].FICS_sub)}>뉴스 더보기</span>
                                        <img src={more} alt='more'/>
                                    </div>

                                </div>
                                <div className='flex_layout'>
                                    <div className='curate_box'>
                                        <p className='curate_msg'>
                                            <span>{today}</span><br/>
                                            {tSummarymsg_n + '\n\n' + mSummarymsg_n}
                                        </p>
                                    </div>
                                    {newsList_n && <CardTextOnImage news={newsList_n[0]}/>}
                                </div>
                                <NewsList newsList={newsList_n.slice(1)} type='vertical' size='3' main='main'/>
                            </div>
                        </div>
                    </>
                }
            </div>
            {loading === false &&  <SummaryCardLayout stockList={industryList} stockList_n={industryList_n} bg='#436178' padding='40px 0 40px 0' type='산업'/>}
        </>

    );
};


export default IndustryNewsLayout;



